exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline[data-v-0ad700c5] {\n  display: inline-block;\n  font-size: 14px;\n}\n.form_style[data-v-0ad700c5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}", ""]);

// exports
